import Dialog from 'react-bootstrap-dialog';
import { findTargetColumn } from '../../gridHelpers/gridHelpers';
import FontAwesome from 'react-fontawesome';
import React from 'react';
import './style.scss';
import { hasGrant } from '../../util/grantHelper';
import * as Grants from '../.././util/grants';

function initialize(self) {
    let currentYear = new Date().getFullYear();
    if (self.state.availableYears.indexOf(currentYear) === -1) {
        self.state.availableYears.push(currentYear);
    }
    if (!self.state.selectedYear.value) {
        self.state.selectedYear = { label: currentYear, value: currentYear };
    }

    for (let i = 0; i < self.state.allocations.length; i++) {
        setTotal(self.state.allocations[i]);
        emptyNulls(self.state.allocations[i]);
        self.state.allocations[i].Changed = false;

        for (let j = 0; j < self.state.allocations[i].Comments.length; j++) {
            self.state.allocations[i].Comments[j].Created = formatDate(self.state.allocations[i].Comments[j]);
        }
    }
    self.setState({});
}

function showCommentDialog(target, row, self) {
    let column = findTargetColumn(target);
    let actions = [];
    actions.push(Dialog.CancelAction());

    if (column)
        actions.push(Dialog.Action('Save to field', () => saveCommentToField(target, row, self), 'btn-info'));
    actions.push(Dialog.Action('Save to row', () => saveCommentToRow(row, self), 'btn-info'));

    self.dialog.show({
        title: "Add comment to field or row.",
        body: "Add a comment to the selected field or row. To add a general comment to all changed rows, press save instead.",
        actions: actions,
        prompt: Dialog.TextPrompt({ initialValue: '', placeholder: 'Enter comment...' })
    });
}

function showSaveDialog(self, titleText, addComment) {
    if (addComment) {
        self.dialog.show({
            title: titleText,
            body: "Add an optional comment when saving. To add a comment to a specific value, right click on the field instead.",
            actions: [
                Dialog.CancelAction(),
                Dialog.Action(titleText, () => self.save(), 'btn-info')
            ],
            prompt: Dialog.TextPrompt({ initialValue: '', placeholder: 'Optional comment...' })
        })
    }
    else {
        self.dialog.show({
            title: titleText,
            body: "Are you sure you want to save allocation?",
            actions: [
                Dialog.CancelAction(),
                Dialog.Action(titleText, () => self.save(), 'btn-info')
            ]
        });
    }
  }

function formatDate(target) {
    // Check if date is already formatted
    if (!target.Created.includes('T')){
        return target.Created;
    }
    let pieces = target.Created.split('T');
    let ymd = pieces[0];
    let hms = pieces[1].split('.')[0];
    return ymd + ' ' + hms;
}

function getDate() {
    var today = new Date();
    var sec = String(today.getSeconds()).padStart(2, '0');
    var min = String(today.getMinutes()).padStart(2, '0');
    var hour = String(today.getHours()).padStart(2, '0');
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    var date = yyyy + '-' + mm + '-' + dd + ' ' + hour + ':' + min + ':' + sec;

    return date;
}

function saveCommentToRow(row, self) {
    let commentValue = self.dialog.promptInput.state.value;

    if (!commentValue)
        return;

    let date = getDate();

    let comment = { CommentId: -1, Value: null, AllocationColumn: null, Year: self.state.selectedYear.value, CustomerId: self.props.clientCode ? self.props.clientCode : null, AllocationId: row.AllocationId, Comment: commentValue, Created: date, CreatedBy: 'Unsaved' };
    row.Comments.unshift(comment);
    self.setState({ unsavedChanges: true});
}

function saveCommentToField(target, row, self) {
    let value = null;
    let column = findTargetColumn(target);

    if (column) {
        value = row[column];
    }
    if (value === undefined || value === null) {
        return;
    }

    if (column === 'ProdType') {
        value = value === 0 ? 'Roll' : value === 1 ? 'Sheet' : 'None';
    }

    let commentValue = self.dialog.promptInput.state.value;

    if (!column) {
        saveCommentToRow(row, self)
        return;
    }

    if (!commentValue || !column)
        return;

    let date = getDate();

    let comment = { CommentId: -1, Value: value, AllocationColumn: column, Year: self.state.selectedYear.value, CustomerId: self.props.clientCode ? self.props.clientCode : null, AllocationId: row.AllocationId, Comment: commentValue, Created: date, CreatedBy: 'Unsaved' };
    row.Comments.unshift(comment);
    self.setState({ unsavedChanges: true});
}

function getCommentIconForField(target, row) {
    let commentList = getCommentsForField(target, row);
    if (!commentList || commentList === '') {
        return '';
    }
    return (
        <FontAwesome name="comments" data-for="globalTip" data-tip={commentList}></FontAwesome>
    )
}

function getCommentIconForFieldWithCustomer(target, row) {
    let commentList = getCommentsForFieldWithCustomer(target, row);
    if (!commentList || commentList === '') {
        return '';
    }
    return (
        <FontAwesome name="comments" data-for="globalTip" data-tip={commentList}></FontAwesome>
    )
}

function getCommentsForField(target, row) {
    let comments = row.Comments.filter(c => c.AllocationColumn === target);
    if (!comments || comments.length === 0)
        return '';

    let commentBox = '<table class="commentTable">';
    let header = '<tr><th>Created</th>' +
        '<th>Created by</th>' +
        '<th>Value</th>' +
        '<th>Field</th>' +
        '<th>Comment</th></tr>';
    commentBox += header;
    comments.forEach((c) => {
        let val = c.Value && c.Value.toString().length > 0 ? c.Value : '';
        let paragraf = '<tr><td>' + c.Created + '</td>' +
            '<td>' + c.CreatedBy + '</td>' +
            '<td>' + val + '</td>' +
            '<td>' + getColumn(c.AllocationColumn) + '</td>' +
            '<td>' + c.Comment + '</td></tr>';
        commentBox += paragraf;
    });
    commentBox += '</table>';

    return commentBox;
}

function getCommentsForFieldWithCustomer(target, row) 
{
    let comments = row.Comments.filter(c => c.AllocationColumn === target);
    if (!comments || comments.length === 0)
        return '';

    let commentBox = '<table class="commentTable">';
    let header = '<tr><th>Created</th>' +
        '<th>Created by</th>' +
        '<th>Customer</th>' +
        '<th>Value</th>' +
        '<th>Field</th>' +
        '<th>Comment</th></tr>';
    commentBox += header;
    comments.forEach((c) => {
        let val = c.Value && c.Value.toString().length > 0 ? c.Value : '';
        let ccr = c.CustomerShortName?.CLIENT_CODE_REGIONAL ?? '';
        let shortName = c.CustomerShortName?.SHORT_NAME ?? '';
        let paragraf = '<tr><td>' + c.Created + '</td>' +
            '<td>' + c.CreatedBy + '</td>' +
            '<td>' + ccr + ' - ' + shortName + '</td>' +
            '<td>' + val + '</td>' +
            '<td>' + getColumn(c.AllocationColumn) + '</td>' +
            '<td>' + c.Comment + '</td></tr>';
        commentBox += paragraf;
    });
    commentBox += '</table>';

    return commentBox;
}

function getColumn(column) {
    let colName = '';
    switch (column) {
        case 'PM':
            colName = 'PM';
            break;
        case 'Country':
            colName = 'Country';
            break;
        case 'Grade':
            colName = 'Grade Code';
            break;
        case 'Grammage':
            colName = 'Grammage';
            break;
        case 'ProdType':
            colName = 'Prod Type';
            break;
        case 'EndUse':
            colName = 'End Use';
            break;
        case 'M1':
            colName = 'Jan';
            break;
        case 'M1':
            colName = 'Jan';
            break;
        case 'M2':
            colName = 'Feb';
            break;
        case 'M3':
            colName = 'Mar';
            break;
        case 'M4':
            colName = 'Apr';
            break;
        case 'M5':
            colName = 'May';
            break;
        case 'M6':
            colName = 'Jun';
            break;
        case 'M7':
            colName = 'Jul';
            break;
        case 'M8':
            colName = 'Aug';
            break;
        case 'M9':
            colName = 'Sep';
            break;
        case 'M10':
            colName = 'Oct';
            break;
        case 'M11':
            colName = 'Nov';
            break;
        case 'M12':
            colName = 'Dec';
            break;
    }

    return colName;
}

function getCommentsForRow(row) {
    let comments = row.Comments.filter(c => c.AllocationColumn === null);

    if (!comments || comments.length === 0)
        return;

    comments.sort((a, b) => a.Created - b.Created);

    let commentBox = '<table class="commentTable">';
    let header = '<tr><th>Created</th>' +
        '<th>Created by</th>' +
        '<th>Comment</th></tr>';
    commentBox += header;
    comments.forEach((c) => {
        let paragraf = '<tr><td>' + c.Created + '</td>' +
            '<td>' + c.CreatedBy + '</td>' +
            '<td>' + c.Comment + '</td></tr>';
        commentBox += paragraf;
    });
    commentBox += '</table>';

    return commentBox;
}

function getCommentsForRowWithCustomer(row) {
    let comments = row.Comments.filter(c => c.AllocationColumn === null);

    if (!comments || comments.length === 0)
        return;

    comments.sort((a, b) => a.Created - b.Created);

    let commentBox = '<table class="commentTable">';
    let header = '<tr><th>Created</th>' +
        '<th>Created by</th>' +
        '<th>Customer</th>' +
        '<th>Comment</th></tr>';
    commentBox += header;
    comments.forEach((c) => {
        let ccr = c.CustomerShortName?.CLIENT_CODE_REGIONAL ?? '';
        let shortName = c.CustomerShortName?.SHORT_NAME ?? '';
        let paragraf = '<tr><td>' + c.Created + '</td>' +
            '<td>' + c.CreatedBy + '</td>' +
            '<td>' +  ccr + ' - ' + shortName + '</td>' +
            '<td>' + c.Comment + '</td></tr>';
        commentBox += paragraf;
    });
    commentBox += '</table>';

    return commentBox;
}

function setTotal(row) {
    // Set total allocation
    let sum = 0;
    for (let i = 1; i <= 12; i++) {
        let prop = "GuiM" + i;
        if (row[prop] !== undefined) {

            let value = parseFloat(row[prop].toString().replace(/,/g, "."));

            if (value) {
                sum += value;
            }
        }
    }
    row.GuiTotal = sum.toFixed(0);
}

function setFromTotal(row, decimals = 1) {
    // Låt ! vara, vi fördelar på 12 om vi inte ska göra uppslag mot produktionscykel, uppdaterar kolumnnamnet så det inte blir tvetydigt.
    if (!row.SetFromTotal) {
        
        let divided = (row.GuiTotal / 12).toFixed(decimals);


        for (let i = 1; i <= 12; i++) {
            let prop = "GuiM" + i;
            if (row[prop] !== undefined) {
                row[prop] = divided;
            }
        }
    }
}

function emptyNulls(row) {
    for (let i = 0; i < 26; i++) {
        if (row[Object.keys(row)[i]] === null) {
            row[Object.keys(row)[i]] = "";
        }
    }
}

function addRemovedRow(target, self) {
    if (target.AllocationId === -1)
        return;

    self.state.removedAllocations.push(target.AllocationId);
}

function addYear(self) {
    let years = self.state.availableYears;
    let latestYear = years.sort()[years.length - 1];
    let year = { label: latestYear + 1, value: latestYear + 1 };
    self.state.availableYears.push(latestYear + 1);
    self.setState({ allocations: [], comments: [], selectedYear: year });
}

function formatMarketAreaDesc(marketAreaCode, desc) {
    if (desc && marketAreaCode) {
        const [firstName, lastName] = desc.split(' ');
        const formattedFirstName = firstName ? firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase() : '';
        const lastInitial = lastName && lastName.length > 0 ? lastName[0] : '';
        return lastInitial ? `${marketAreaCode}-${formattedFirstName} ${lastInitial}` : `${marketAreaCode}-${formattedFirstName}`;
    }
}

export { formatDate, initialize, addYear, addRemovedRow, setTotal, setFromTotal, getCommentsForField, getCommentsForRow, showCommentDialog, showSaveDialog, getCommentIconForField, getCommentIconForFieldWithCustomer, getCommentsForRowWithCustomer, formatMarketAreaDesc };